const loginWithKeyList = [
  {
    icon: " keyboard_voice",
    key: "configuration.voicePicker",
    name: "Old Voice Picker",
    url: "home/app/oldvoicePicker",
    description: "Voice Picker",
    disabled: false,
    productionReady: true,
  },
  {
    icon: "backup_icon",
    key: "backuprecordingfile",
    name: "Voice Picker",
    url: "home/app/configurations/new-voice-picker",
    description: "Backup and Download ",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "download_for_offline_icon",
    key: "backupdownloadfile",
    name: "Backup Download File ",
    url: "home/app/configurations/backup-download-file ",
    description: "User Can Backup file download in this  Page ",
    productionReady: true,
    disabled: false,
  },
  {
    name: "Menu's Dashboard",
    key: "auth-default",
    url: "/app/menudashboard/home",
    description: "Menu Dashboard",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "account_circle",
    key: "change-User-Profile",
    name: "Change-User-Profile",
    url: "home/app/configurations/profile",
    description: "",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "account_box",
    key: "uc.settings",
    name: "User Profile",
    url: "home/app/uc/settings",
    description: "",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "edit",
    key: "configuration.billing-cdr",
    name: "Billing CDR",
    url: "home/app/billing/Cdr",
    description: "",
    productionReady: true,
  },
  {
    icon: "extension",
    key: "extension-billing-reports",
    name: "Extension-Billing-Reports",
    url: "home/app/extension-billing-reports",
    description: "",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "calendar_month_icon",
    key: "uc.conference.calendar",
    name: "Conference Calendar",
    description: "",
    url: "home/app/",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "settings",
    key: "uc.conference.setting",
    name: "Conference Setting",
    description: "",
    url: "home/app/",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "people",
    key: "active.conference.participants",
    name: "Active Conference Participants",
    description: "",
    url: "home/app/",
    productionReady: true,
    disabled: false,
  }
];

export { loginWithKeyList };
